import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavigationMenuHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "navigation-menu-horizontal" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.375,
			cy: 12.023,
			r: 2.625,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20.625,
			cy: 12.023,
			r: 2.625,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12.023,
			r: 2.625,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		})
	]
});
export { SvgNavigationMenuHorizontal as ReactComponent };
